import { CustomerThemeProvider } from '@/styles/themes/CustomerThemeProvider';

import { EntityDiagramContextContainer } from './components/EntityDiagramContextContainer';
import { EntityDiagramFlowChartWrapper } from './components/EntityDiagramFlowChartWrapper';
import { MemoizedNodeSummaryPanel } from './components/NodeSummaryPanel';
import { useEntityDiagramContext } from './contexts/entityDiagram.context';
import { EntityDiagramFlowChart } from './EntityDiagramFlowChart';
import { EntityDiagramProps } from './types';

interface EntityDiagramComponentProps extends EntityDiagramProps {
  onEditClick?: () => void;
  hideFullscreenButton?: boolean;
  // Renders the diagram without the surrounding card frame (e.g. full-bleed edit mode)
  hideBorder?: boolean;
}

export const EntityDiagram = ({
  height,
  width,
  householdId,
  entityId,
  setSelectedPrimaryClientId,
  onEditClick,
  hideFullscreenButton,
  hideBorder,
}: EntityDiagramComponentProps) => {
  const { getState } = useEntityDiagramContext();
  const {
    presentationMode,
    entity,
    primaryClients,
    selectedPrimaryClientId,
    entityDiagramVariant,
    viewOnlyMode,
    renderWhiteLabeled,
  } = getState();

  const flowChartContent = (
    <EntityDiagramFlowChartWrapper
      height={height}
      presentationMode={presentationMode}
      hideBorder={viewOnlyMode || hideBorder}
    >
      <EntityDiagramFlowChart
        entityId={entityId}
        householdId={householdId}
        entity={entity}
        primaryClients={primaryClients}
        presentationMode={presentationMode}
        selectedPrimaryClientId={selectedPrimaryClientId}
        setSelectedPrimaryClientId={setSelectedPrimaryClientId}
        entityDiagramVariant={entityDiagramVariant}
        viewOnlyMode={viewOnlyMode}
        onEditClick={onEditClick}
        hideFullscreenButton={hideFullscreenButton}
      />
    </EntityDiagramFlowChartWrapper>
  );

  return (
    <EntityDiagramContextContainer height={height} width={width}>
      {presentationMode ? (
        flowChartContent
      ) : (
        <CustomerThemeProvider forceLuminaryTheme={!renderWhiteLabeled}>
          {flowChartContent}
        </CustomerThemeProvider>
      )}
      <MemoizedNodeSummaryPanel
        householdId={householdId}
        style={{ height }}
        isOnEntityPage={true}
      />
    </EntityDiagramContextContainer>
  );
};
